import { Chip, Stack } from "@mui/material";
import { LABOR_CERTIFICATE } from "../laborCertificate";
import { NEUTRAL_CHIP_BG } from "../../../utils/colors";

const LaborCertificateChip = ({ onClick, sx }) => {
  return (
    <Stack direction="row" spacing={1} sx={{ justifyContent: "flex-start", ...sx, mt: 1.75 }}>
      <Chip
        label={LABOR_CERTIFICATE.label}
        onClick={onClick}
        size="small"
        sx={{
          borderRadius: "8px",
          fontWeight: 400,
          fontSize: 13,
          height: "auto",
          backgroundColor: NEUTRAL_CHIP_BG,
          color: "text.primary",
          "& .MuiChip-label": {
            px: 0.75,
            py: 0.35,
          },
          "&:hover": {
            backgroundColor: "#DDE4EC",
          },
        }}
      />
    </Stack>
  );
};

export default LaborCertificateChip;
